import { countryFlags } from "../utils/country_flags";
import { team_logos } from "../utils/team_logos";
import Icon from "./Icon";

// Dark color palette with 16 colors
const COLOR_PALETTE = [
  '#1A252F', // Very dark blue-gray
  '#5D2A6B', // Very dark purple
  '#1B5E20', // Very dark green
  '#B71C1C', // Very dark red
  '#E65100', // Very dark orange
  '#0D47A1', // Very dark blue
  '#4A148C', // Very dark violet
  '#004D40', // Very dark teal
  '#BF360C', // Very dark orange-red
  '#212121', // Very dark slate
  '#00695C', // Very dark green-blue
  '#BF360C', // Very dark orange-brown
  '#1565C0', // Very dark blue
  '#424242', // Very dark gray
  '#8D1B1B', // Very dark red-brown
  '#5D4037'  // Very dark saddle brown
];

// Simple hash function to convert string to number
const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
};

// Get consistent color for team name
const getTeamColor = (teamName: string): string => {
  const hash = hashString(teamName);
  const colorIndex = hash % COLOR_PALETTE.length;
  return COLOR_PALETTE[colorIndex];
};

const TeamIcon = ({name, flag, size, flagMargin, iconMargin, opacity} : {
    name: string,
    flag?: string,
    size: number,
    flagMargin?: number,
    iconMargin?: number,
    opacity?: number,
  }) => {
  if(!flag && team_logos.includes(name)) {
    return <Icon 
      name={name}
      size={size}
      url={`https://cs2lens-team-logos.s3.eu-west-1.amazonaws.com/${name}.png`}
      shadowStrength={0.8}
      shadowDistance={1}
      margin={iconMargin ?? 10}
      opacity={opacity ?? 1}
    />;
  }
  else {
    if (flag && flag in countryFlags) {
      return <span style={{marginRight: flagMargin ?? 10, opacity: opacity ?? 1}}>{countryFlags[flag]}</span>
    }
    
    // Render bordered circle with first character of team name
    const firstChar = name.charAt(0).toUpperCase();
    const backgroundColor = getTeamColor(name);
    const circleSize = size;
    
    return (
      <div
        style={{
          width: circleSize,
          height: circleSize,
          borderRadius: '50%',
          backgroundColor: backgroundColor,
          border: `2px solid #ddd`,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#eee',
          fontSize: Math.max(circleSize * 0.4, 8),
          fontWeight: 'bold',
          marginRight: iconMargin ?? 10,
          opacity: opacity ?? 1,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
          verticalAlign: 'middle'
        }}
      >
        {firstChar}
      </div>
    );
  }
}

export default TeamIcon;